export var TARGET_CLS = 'ant-wave-target';